import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { Button, Header, Breadcrumbs, Slider, NoticeBanner } from "../../components";

import { useAppDispatch } from "../../redux/store";
import { fetchGetClubImages, fetchGetHallsGallery } from "../../redux/images/asyncActions";
import { imagesSelector } from "../../redux/images/selectors";
import { selectNoticesFor } from "../../redux/notices/selectors";

import styles from "./MainPage.module.scss";
import preloader from "../../assets/img/load.gif";

import { MainPagePropsType } from "./types";
import { IClubImage, IHallGalleryItem } from "../../redux/images/types";

import chooseSubs from "../../assets/img/chooseSubs.svg";
import chooseHall from "../../assets/img/choseHall.svg";

export const MainPage: React.FC<MainPagePropsType> = ({ title }) => {
  const { clubImages, hallsGallery, isLoading } = useSelector(imagesSelector);
  const clubNotices = useSelector(selectNoticesFor("CLUB_CARD"), shallowEqual);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  React.useEffect(() => {
    dispatch(fetchGetClubImages());
    dispatch(fetchGetHallsGallery());
  }, [dispatch]);

  const clubImagesArray = Array.isArray(clubImages) 
    ? clubImages
        .filter((img: IClubImage) => img.url)
        .map((img: IClubImage) => img.url)
    : [];

  const allHallsImages: string[] = [];
  if (Array.isArray(hallsGallery)) {
    hallsGallery.forEach((hall: IHallGalleryItem) => {
      if (hall.images && Array.isArray(hall.images)) {
        hall.images.forEach((img: IClubImage) => {
          if (img.url) {
            allHallsImages.push(img.url);
          }
        });
      }
    });
  }

  return (
    <>
      <Header title={title} />
      <main>
        <div className="container">
          <Breadcrumbs />
        </div>
        <section className="container container--mobileFull">
          <h1 className={styles.mainTitle}>
            Фитнес клуб с бассейном всего за 10 000 руб в месяц. Оплата в один клик!
          </h1>

          <div className={styles.offerBoxes}>
            <div className={styles.offerBox}>
              <img src={chooseSubs} alt="chooseSubs" className={styles.backImage} />
              
              <div className={styles.offerBoxText}>
                <NoticeBanner notices={clubNotices} newStyles={styles.offerBoxNotice} />
                <h2 className={styles.offerBoxTitle}>Фитнес-клуб с бассейном</h2>
                <p className={styles.offerBoxPrice}>от 10000р</p>
              </div>
              
              <Button newStyles={styles.offerBoxButton} to="/subscriptions">
                Выбрать абонемент
              </Button>
            </div>

            <div className={styles.offerBox}>
              <img src={chooseHall} alt="chooseHall" className={styles.backImage} />
              
              <div className={styles.offerBoxText}>
                <h2 className={styles.offerBoxTitle}>10 фитнес-залов для аренды</h2>
                <p className={styles.offerBoxPrice}>от 1000р</p>
              </div>
              
              <Button newStyles={styles.offerBoxButton} to="/halls">
                Выбрать зал
              </Button>
            </div>
          </div>

          <div className={styles.photosSection}>
            <div className={styles.photoBlock}>
              {isLoading ? (
                <Preloader />
              ) : clubImagesArray.length > 0 ? (
                <Slider newStyle="slider_small_img" images={clubImagesArray} />
              ) : (
                <div className={styles.photoPlaceholder}>Фото клуба</div>
              )}
              <Button 
                newStyles={styles.photoButton} 
                onClickFunc={() => navigate("/about/clubFoto")}
                disabled={clubImagesArray.length === 0}
              >
                Все фото
              </Button>
            </div>

            <div className={styles.photoBlock}>
              {isLoading ? (
                <Preloader />
              ) : allHallsImages.length > 0 ? (
                <Slider newStyle="slider_small_img" images={allHallsImages} />
              ) : (
                <div className={styles.photoPlaceholder}>Фото залов</div>
              )}
              <Button 
                newStyles={styles.photoButton} 
                onClickFunc={() => navigate("/about/hallsFoto")}
                disabled={allHallsImages.length === 0}
              >
                Все фото
              </Button>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

const Preloader: React.FC = () => {
  return <img className={styles.preloader} src={preloader} alt="loading" />;
};
